let skuSeparator = ";"; // 属性分隔符
let zqKey = '租赁时长';

function build(_skus,rentType){
  var skus = _skus; //resetAttributesJson(_skus,rentType);
  var keys = buildKeys(skus);
  var values = buildValues(skus);
  var resultSKU = initSKU(values);
  return {keys:checkSku(keys,resultSKU).keys,sku:resultSKU};
}


function toJson(str){
  try{
    if(str.indexOf('{') <  0){
      return null;
    }
    return JSON.parse(str);
  }catch(e){}
  return null;
}

function copy(sku){
  var str = JSON.stringify(sku);
  return JSON.parse(str);
}

/*
function resetAttributesJson(skus,rentType){
  var nSku = [];
  var unit = rentType == 'day' ? '天' : '个月';
  skus.forEach(sku =>{
    var month = toJson(rentType === 'day' ? sku.salePriceDay : sku.salePriceMonth);
    if(month == null){
      month = {'12':(rentType === 'day' ? sku.salePriceDay : sku.salePriceMonth)};
    }
    Object.keys(month).forEach(day=>{
      var _ss = copy(sku);
      _ss.attributesJson.push({key:zqKey,value:day+unit});
      nSku.push(_ss);
    });
  });
  return nSku;
}
*/


function buildValues(skus){
  var obj = {};
  skus.forEach(sku => {
    var keys = sku.attributesJson.map(item => {return item.value.trim()}).join(skuSeparator);
    obj[keys] = {
      sku:sku,
      count:sku.inventoryNum,
      price:0
    };
  });
  return obj;
}

function buildKeys(skus){
  var obj = {};
  skus.forEach(function(item){
    item.attributesJson.forEach(function(attr){
      var key = attr.key.replace(/(^\s*)|(\s*$)/g,'');
      var value = attr.value.replace(/(^\s*)|(\s*$)/g,'');
      var val = obj[key] == undefined ? {} : obj[key];
      val[value] = '1';
      obj[key] = val;
    });
  });
  return Object.keys(obj).map(item=>{
    return {name:item,item:Object.keys(obj[item]).sort().map(v => {
      return {name:v,actived:false,disabled:false}
    })};
  });
}

// 从m中取n的所有组合
function getFlagArrs(m, n) {
    var flagArrs = [],
        flagArr = [],
        isEnd = false;
    for(var i = 0; i < m; i++){
        flagArr[i] = i < n ? 1 : 0;
    }
    flagArrs.push(flagArr.concat());
    // 当n不等于0并且m大于n的时候进入
    if(n && m > n){
        while(!isEnd){
            var leftCnt = 0;
            for(var i = 0; i < m - 1; i++){
                if (flagArr[i] == 1 && flagArr[i + 1] == 0){
                    for(var j = 0; j < i; j++){
                        flagArr[j] = j < leftCnt ? 1 : 0;
                    }
                    flagArr[i] = 0;
                    flagArr[i + 1] = 1;
                    var aTmp = flagArr.concat();
                    flagArrs.push(aTmp);
                    if(aTmp.slice(-n).join('').indexOf('0') == -1){
                        isEnd = true;
                    }
                    break;
                }
                flagArr[i] == 1 && leftCnt++;
            }
        }
    }
    return flagArrs;
}


function initSKU(sku){
    var resultSKU = [];
    var skuKeys = getObjKeys(sku);
    for(var i in skuKeys){
        var skuKey = skuKeys[i]; // 获取一条SKU的key
        var skuData = sku[skuKey]; // 获取一条SKU的相关数据
        var skuKeyAttrs = skuKey.split(skuSeparator); // 获取SKU的key的属性数组
        var combArr = arrayCombine(skuKeyAttrs);
        for(var j = 0; j < combArr.length; j++){
            var key = combArr[j].join(skuSeparator);
            if(resultSKU[key]){
                resultSKU[key].count += skuData.count;
                resultSKU[key].prices.push(skuData.price);
            }else{
                resultSKU[key] = {
                    sku:skuData.sku,
                    count: skuData.count,
                    prices:[skuData.price]
                };
            }
        }
    }
    return resultSKU;
}

function getObjKeys(obj){
    if(obj !== Object(obj)){
        throw new TypeError('Invalid object');
    }
    var keys = [];
    for(var key in obj){
        if(Object.prototype.hasOwnProperty.call(obj, key)){
            keys[keys.length] = key;
        }
    }
    return keys;
}

function arrayCombine(targetArr){
    var resultArr = [];
    for(var n = 0; n <= targetArr.length; n++){
        var flagArrs = getFlagArrs(targetArr.length, n);
        while(flagArrs.length){
            var flagArr = flagArrs.shift();
            var combArr = Array(targetArr.length);
            for(var i = 0; i < targetArr.length; i++){
                if(flagArr[i]){
                    combArr[i] = targetArr[i];
                }
            }
            resultArr.push(combArr);
        }
    }
    return resultArr;
}

function copyArray(sku){
  var ret = [];
  sku.forEach(item => {
    ret.push(item);
  });
  return ret;
}

function checkSku(keys,resultSKU){
  var sku = [],over = true;
  keys.forEach(item => {
    var activeds = item.item.filter(k => k.actived);
    sku.push(activeds.length > 0 ? activeds[0].name : '');
    over = activeds.length > 0;
  });


  keys.forEach((item,index) =>{
    var curr = copyArray(sku);
    item.item.forEach((k,j)=>{
      curr[index] = k.name;
      var obj = resultSKU[curr.join(skuSeparator)];
      k.disabled = obj == undefined || (!k.actived && obj.count == 0);
    });
  });
  // return {keys:keys,sku:over ? resultSKU[sku.join(skuSeparator)].sku : null};
  var sku2=JSON.parse(JSON.stringify(sku))
  return {keys:keys,sku:over ? (resultSKU[sku2.join(skuSeparator)]?(resultSKU[sku2.join(skuSeparator)].sku):(resultSKU[(sku2.reverse()).join(skuSeparator)].sku)) : null};
}

function getSelectSku(keys,resultSKU,rentType){
  var sku = [],over = true;
  keys.forEach(item => {
    console.log(item);
    var activeds = item.item.filter(k => k.actived);
    sku.push(activeds.length > 0 ? activeds[0].name : '');
    if(rentType === 'buy' && item.name === zqKey){ // 购买订单不校验租期
      // over = true;
    }else{
      over = activeds.length > 0;
    }
  });
    // return over && sku.length > 0 ? resultSKU[sku.join(skuSeparator)].sku : null;
  var sku2=JSON.parse(JSON.stringify(sku))
  return over && sku.length > 0 ?(resultSKU[sku2.join(skuSeparator)]?(resultSKU[sku2.join(skuSeparator)].sku):(resultSKU[(sku2.reverse()).join(skuSeparator)].sku)) : null
}

function buildIcons(icons){
  if(icons == null || icons == undefined || icons === ''){
    return {};
  }
  var array = JSON.parse(icons);
  var ret = {};
  for(var i = 0 ;i < array.length ; i ++){
    var row = array[i];
    ret[row.name] = row.icon;
  }
  return ret;
}

function getSelectTimeLen(sku){
  var attr = sku.attributesJson.filter(item=>item.key == zqKey);
  console.log(attr,122)
  if(attr.length > 0){
    return parseInt(attr[0].value.replace(/天/g,''));
  }
  return 12;
}

function getCurrentActiveTimeLen(keys){
  var tLen = keys.filter(item=>item.name === zqKey)[0].item.filter(item=>item.actived);
  if(tLen.length <= 0){
    return null;
  }
  var vv = tLen[0].name.replace(/个月/g,'').replace(/天/g,'');
  var ret = [];
  keys.filter(item=>item.name !== zqKey).forEach(item =>{
    var iitem = item.item.filter(kv =>kv.actived);
    if(iitem.length > 0){
      ret.push(item.name+iitem[0].name+vv);
    }
  });
  return ret.length > 0 ? ret : null;
}

export {
  build,checkSku,getSelectSku,buildIcons,
  getSelectTimeLen,getCurrentActiveTimeLen
}